import script from "./StepForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StepForm.vue?vue&type=script&setup=true&lang=js"

import "./StepForm.vue?vue&type=style&index=0&id=ac1eed28&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac1eed28"]])

export default __exports__